import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/API/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../services/Alert/alert.service';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrl: './offers.component.scss'
})
export class OffersComponent implements OnInit {

  isLoading: boolean = false;
  guestFavorites: any[] = [];
  subCategoryProducts: any[] = [];

  constructor(private apiService: ApiService,private alertService: AlertService) { }

  ngOnInit(): void {
    this.getSubCategoryProducts()
    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('romaPizza_token')?.toString();
    if(guestMode){
      this.loadGuestFavorites();
    }
  }

  loadGuestFavorites() {
    const storedFavorites = sessionStorage.getItem('favoriteItems');
    this.guestFavorites = storedFavorites ? JSON.parse(storedFavorites) : [];
    
    // Initialize as empty array if parsing fails
    if (!Array.isArray(this.guestFavorites)) {
      this.guestFavorites = [];
      sessionStorage.setItem('favoriteItems', JSON.stringify([]));
    }
  }

  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  totalPages: number = 1;

  getSubCategoryProducts(page: number = 1){
    this.isLoading = true;
    this.apiService.offers(page).subscribe({
      next: response => {
        this.subCategoryProducts = response.data.data;
        this.isLoading = false;
        this.totalItems = response.data.totalCount;
        this.totalPages = response.data.totalPages;
        this.currentPage = page;
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
        this.isLoading = false;
      }
    });
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.getSubCategoryProducts(page);
    }
  }

  subCategories: any[] = [];
  activeSubCategory: number | null = null; 
  selectSubCategory(subCategoryId: number) {
    this.activeSubCategory = subCategoryId;
    this.currentPage = 1; // Reset to first page when changing category
    this.getSubCategoryProducts(this.currentPage);
  }

  getPagesArray(): number[] {
    const pages = [];
    const maxVisiblePages = 5; // Adjust as needed
    
    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);
    
    // Adjust if we're at the start or end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  }

  updateProductFavoriteStates() {
    this.subCategoryProducts.forEach(product => {
      product.isFavorite = this.isFavorite(product.id);
    });
  }

  // Check if item is favorited (for both guest and logged-in)
  isFavorite(itemId: number): boolean {
    // For logged-in users (implement your actual logic)
    if (localStorage.getItem('romaPizza_token')) {
      return false; // Replace with your actual check
    }
    
    // For guest users
    if (!Array.isArray(this.guestFavorites)) {
      console.error('guestFavorites is not an array', this.guestFavorites);
      this.guestFavorites = [];
      return false;
    }
    
    return this.guestFavorites.some(fav => fav?.id === itemId);
  }

  toggleFav(itemId: number) {
    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('romaPizza_token')?.toString();
    const item = this.subCategoryProducts.find(item => item.id === itemId);

    if (!item) {
      this.alertService.danger('Item not found');
      return;
    }

    if (token) {
      // Existing logged-in user flow
      this.apiService.toggleFavoriteProduct(itemId).subscribe({
        next: response => {
          if (response.success) {
            this.alertService.success(response.message);
            this.selectSubCategory(this.subCategories[0].id);
          }
        }, 
        error: (error: HttpErrorResponse) => {
          this.alertService.danger(error.error.message);
        }
      });
    } else if (guestMode) {
      // Toggle guest favorites
      const existingIndex = this.guestFavorites.findIndex(fav => fav.id === itemId);
      
      if (existingIndex > -1) {
        // Remove if exists
        this.guestFavorites.splice(existingIndex, 1);
        this.alertService.success('Removed from wishlist');
      } else {
        // Add if doesn't exist
        this.guestFavorites.push(item);
        this.alertService.success('Added to wishlist');
      }
      
      // Update storage and component state
      sessionStorage.setItem('favoriteItems', JSON.stringify(this.guestFavorites));
      
      // Update UI immediately
      this.updateProductFavoriteStates();
    } else {
      this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a>');
    }
  }

  calculateDiscountedPrice2(product: any, price: number): number {
    if (!product?.offer) return price;
    
    if (product.offer.type === 'discount') {
      return Math.max(0, price - product.offer.value); // Ensure price doesn't go negative
    } 
    else if (product.offer.type === 'percentage') {
      return price * (1 - product.offer.value / 100);
    }
    
    return price;
  }
  calculateDiscountedPrice(item: any): number {
    if (!item.offer) return item.types[0].price;
    
    const basePrice = item?.types[0]?.price;
    
    if (item.offer.type === 'discount') {
      console.log(basePrice);
      return basePrice - item.offer.value;
    } 
    else if (item.offer.type === 'percentage') {
      return basePrice * (1 - item.offer.value / 100);
    }
    return basePrice;
  }

  getOfferText(offer: any): string {
    if (!offer) return '';
    
    if (offer.type === 'discount') {
      return `-${offer.value}$`;
    } 
    else if (offer.type === 'percentage') {
      return `-${offer.value}%`;
    }
    
    return '';
  }

  selectedProduct: any = {};
  selectedSize: number | null = null;
  quantity: number = 1;
  extras: any[] = []; // For future implementation if needed
  selectedExtras: any[] = [];
  // selectProduct(productId: number) {
  //   if (productId) {
  //     this.apiService.getSelectedProduct(productId).subscribe({
  //       next: response => {
  //         this.selectedProduct = response.data.selectedProduct;
  //         console.log(this.selectedProduct);
  //         // Reset selections
  //         this.selectedExtras = [];
  //         // Initialize extras with selected=false
  //         if (this.selectedProduct.extraproducts) {
  //             this.selectedProduct.extraproducts.forEach(extra => extra.selected = false);
  //         }
  //         // Auto-select first size if available
  //         if (this.selectedProduct.types?.length) {
  //             this.selectedSize = this.selectedProduct.types[0].id;
  //         }
  //       }, 
  //       error: (error: HttpErrorResponse) => {
  //         console.log(error);
  //         this.alertService.danger('Something went wrong!');
  //       }
  //     });
  //   }
  // }

  // updateSelectedExtras() {
  //   this.selectedExtras = this.selectedProduct.extraproducts.filter(extra => extra.selected);
  // }

  // calculateTotal(): number {
  //   if (!this.selectedProduct || !this.selectedSize) return 0;
    
  //   // Find the selected size
  //   const selectedType = this.selectedProduct.types.find(t => t.id === this.selectedSize);
  //   if (!selectedType) return 0;
    
  //   // Calculate base price (with discount if applicable)
  //   let basePrice = this.selectedProduct.offer 
  //     ? this.calculateDiscountedPrice2(this.selectedProduct, selectedType.price)
  //     : selectedType.price;
    
  //   let total = basePrice * this.quantity;
    
  //   // Add extras (extras typically aren't discounted)
  //   if (this.selectedProduct.extraproducts) {
  //     this.selectedProduct.extraproducts.forEach(extra => {
  //       if (extra.selected) {
  //         total += extra.price * this.quantity;
  //       }
  //     });
  //   }
    
  //   return total;
  // }


  // increaseQuantity() {
  //   if (this.quantity < 99) this.quantity++;
  // }

  // decreaseQuantity() {
  //   if (this.quantity > 1) this.quantity--;
  // }

  // addToCart() {
  //   if (!this.selectedSize) {
  //     this.alertService.danger('Please select a size');
  //     return;
  //   }

  //   const selectedType = this.selectedProduct.types.find(
  //     (t: any) => t.id === this.selectedSize
  //   );

  //   const selectedExtraIds = this.selectedExtras.map(extra => extra.id);

  //   const cartItem = {
  //     products: [{
  //       product_id: this.selectedProduct.id,
  //       type: selectedType.id,
  //       quantity: this.quantity,
  //       extra: selectedExtraIds
  //     }]
  //   };

  //   // Implement your cart service here
  //   console.log('Adding to cart:', cartItem);

  //   const guestMode = sessionStorage.getItem('guestMode');
  //   const token = localStorage.getItem('romaPizza_token')?.toString();
  //   if(cartItem){
  //     if(token){
  //       if(this.selectedProduct.id){
  //         this.apiService.addToCart(cartItem).subscribe({
  //           next: response => {
  //             if(response.success == true){
  //               this.alertService.success(response.message);
  //               // this.selectSubCategory(this.subCategories[0].id);
  //             }
  //           }, 
  //           error: (error: HttpErrorResponse) => {
  //             this.alertService.danger(error.error.message);
  //           }
  //         });
  //       }
  //     }else if(guestMode){
  //       this.handleGuestCart(selectedType,selectedExtraIds);
  //     }else{
  //       this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to add products to your cart');
  //     }
  //   }
  // }
  
  // private handleGuestCart(selectedType: any,selectedExtraIds: number[]) {
  //   // Get existing cart items or initialize empty array
  //   let cartItems: any[] = [];
  //   const storedCart = sessionStorage.getItem('cartItems');
    
  //   if (storedCart) {
  //     try {
  //       cartItems = JSON.parse(storedCart);
  //       if (!Array.isArray(cartItems)) {
  //         cartItems = []; // Reset if corrupted data
  //       }
  //     } catch (e) {
  //       console.error('Error parsing cart items', e);
  //       cartItems = [];
  //     }
  //   }

  //   // Prepare the new item
  //   const newItem = {
  //     product_id: this.selectedProduct.id,
  //     name: this.selectedProduct.name,
  //     avatar: this.selectedProduct.avatar,
  //     types: this.selectedProduct.types,
  //     components: this.selectedProduct.components,
  //     selectedTypeId: selectedType.id,
  //     type_name: selectedType.name,
  //     price: selectedType.price,
  //     quantity: this.quantity,
  //     extra: this.selectedExtras.filter(extra => selectedExtraIds.includes(extra.id)),
  //     offer: this.selectedProduct.offer
  //   };

  //   // Check if same product with same type already exists
  //   const existingItemIndex = cartItems.findIndex(item => 
  //     item.product_id === newItem.product_id && 
  //     item.selectedTypeId === newItem.selectedTypeId
  //   );

  //   if (existingItemIndex > -1) {
  //     // Update quantity if same product and type exists
  //     cartItems[existingItemIndex].quantity += newItem.quantity;
  //     this.alertService.success(`Quantity updated (${cartItems[existingItemIndex].quantity})`);
  //   } else {
  //     // Add as new item if different product or type
  //     cartItems.push(newItem);
  //     this.alertService.success('Added to cart'); 
  //   }

  //   // Save updated cart
  //   sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
  //   console.log('Updated cart:', cartItems);
  // }



  // new functions
  selectedFreeSides: any[] = [];
  extraQuantities: { [key: number]: number } = {};
  selectProduct(productId: number) {
    if (productId) {
      this.apiService.getSelectedProduct(productId).subscribe({
        next: response => {
          this.selectedProduct = response.data.selectedProduct;
          console.log(this.selectedProduct);
          
          // Reset selections
          this.selectedExtras = [];
          this.selectedFreeSides = [];
          this.extraQuantities = {};
          
          // Initialize extras with quantity 0
          if (this.selectedProduct.extraproducts) {
              this.selectedProduct.extraproducts.forEach(extra => {
                  this.extraQuantities[extra.id] = 0;
              });
          }
          
          // Auto-select first size if available
          if (this.selectedProduct.types?.length) {
              this.selectedSize = this.selectedProduct.types[0].id;
          }
        }, 
        error: (error: HttpErrorResponse) => {
          console.log(error);
          this.alertService.danger('Something went wrong!');
        }
      });
    }
  }

  updateSelectedExtras() {
    this.selectedExtras = [];
    if (this.selectedProduct.extraproducts) {
        this.selectedProduct.extraproducts.forEach(extra => {
            const quantity = this.extraQuantities[extra.id] || 0;
            if (quantity > 0) {
                // Add the extra product multiple times based on quantity
                for (let i = 0; i < quantity; i++) {
                    this.selectedExtras.push(extra);
                }
            }
        });
    }
  }

  increaseQuantity() {
    if (this.quantity < 99) this.quantity++;
  }

  decreaseQuantity() {
    if (this.quantity > 1) this.quantity--;
  }
  addToCart() {
    if (!this.selectedSize) {
        this.alertService.danger('Please select a size');
        return;
    }

    const selectedType = this.selectedProduct.types.find(
        (t: any) => t.id === this.selectedSize
    );

    // Create extras array with name, quantity, and price
    const extras: any[] = [];
    if (this.selectedProduct.extraproducts) {
        this.selectedProduct.extraproducts.forEach(extra => {
            const quantity = this.extraQuantities[extra.id] || 0;
            if (quantity > 0) {
                extras.push({
                    name: extra.name,
                    quantity: quantity,
                    price: extra.price
                });
            }
        });
    }

    // Get free side IDs
    const freeSideIds = this.selectedFreeSides.map(side => side.id);

    const cartItem = {
        products: [{
            product_id: this.selectedProduct.id,
            type: selectedType.id,
            quantity: this.quantity,
            extra: extras, // Array of objects with name, quantity, price
            side: freeSideIds // Array of free side IDs
        }]
    };
    console.log('Cart item for API:', cartItem);

    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('romaPizza_token')?.toString();
    
    if (cartItem) {
        if (token) {
            if (this.selectedProduct.id) {
                this.apiService.addToCart(cartItem).subscribe({
                    next: response => {
                        if (response.success == true) {
                            this.alertService.success(response.message);
                        }
                    }, 
                    error: (error: HttpErrorResponse) => {
                        this.alertService.danger(error.error.message);
                    }
                });
            }
        } else if (guestMode) {
            // For guest mode, we need to update handleGuestCart to handle the new format
            this.handleGuestCart(selectedType, extras, freeSideIds);
        } else {
            this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to add products to your cart');
        }
    }
  }
  private handleGuestCart(selectedType: any, extras: any[], freeSideIds: number[]) {
      // Get existing cart items or initialize empty array
      let cartItems: any[] = [];
      const storedCart = sessionStorage.getItem('cartItems');
      
      if (storedCart) {
          try {
              cartItems = JSON.parse(storedCart);
              if (!Array.isArray(cartItems)) {
                  cartItems = []; // Reset if corrupted data
              }
          } catch (e) {
              console.error('Error parsing cart items', e);
              cartItems = [];
          }
      }

      // Get full free sides information
      const selectedFreeSidesFullInfo = this.selectedProduct.sideproducts?.filter(side => 
          freeSideIds.includes(side.id)
      ).map(side => ({
          id: side.id,
          name: side.name,
          abbrev: side.abbrev,
          price: side.price
      })) || [];

      // Prepare the new item in the exact format you want
      const newItem = {
          id: this.selectedProduct.id,
          name: this.selectedProduct.name,
          avatar: this.selectedProduct.avatar,
          offer: this.selectedProduct.offer,
          rate: this.selectedProduct.rate || 0,
          components: this.selectedProduct.components,
          types: this.selectedProduct.types,
          extraproducts: this.selectedProduct.extraproducts,
          selectedTypeId: selectedType.id,
          selectedExtraId: extras, // Store extras directly in selectedExtraId as objects
          quantity: this.quantity,
          category_name: this.selectedProduct.categoryName || 'Menu',
          selectedFreeSides: selectedFreeSidesFullInfo // Store full free sides objects
      };

      // Check if same product exists with same type AND same extras AND same free sides
      const existingItemIndex = cartItems.findIndex(item => {
          // First check if it's the same product and type
          if (item.id !== newItem.id || item.selectedTypeId !== newItem.selectedTypeId) {
              return false;
          }
          
          // Compare extras using the new format
          const areExtrasEqual = this.areExtrasEqualNewFormat(item.selectedExtraId, newItem.selectedExtraId);
          
          // Compare free sides using full objects
          const areFreeSidesEqual = this.areFreeSidesEqualObjects(item.selectedFreeSides, newItem.selectedFreeSides);
          
          return areExtrasEqual && areFreeSidesEqual;
      });

      if (existingItemIndex > -1) {
          // Update quantity if same product, type, extras AND free sides
          cartItems[existingItemIndex].quantity += newItem.quantity;
          this.alertService.success(`Quantity updated (${cartItems[existingItemIndex].quantity})`);
      } else {
          // Add as new item if different product, type, extras OR free sides
          cartItems.push(newItem);
          this.alertService.success('Added to cart'); 
      }

      // Save updated cart
      sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
      console.log('Updated cart:', cartItems);
  }

  // Helper method to compare selectedExtraId arrays
  // private areExtraIdsEqual(extras1: number[], extras2: number[]): boolean {
  //     if (!extras1 && !extras2) return true;
  //     if (!extras1 || !extras2) return false;
  //     if (extras1.length !== extras2.length) return false;
      
  //     // Sort and compare arrays
  //     const sorted1 = [...extras1].sort();
  //     const sorted2 = [...extras2].sort();
      
  //     return sorted1.every((value, index) => value === sorted2[index]);
  // }
  // private areFreeSidesEqual(sides1: any[], sides2: any[]): boolean {
  //     if (!sides1 && !sides2) return true;
  //     if (!sides1 || !sides2) return false;
  //     if (sides1.length !== sides2.length) return false;
      
  //     const sorted1 = [...sides1].sort((a, b) => a.id - b.id);
  //     const sorted2 = [...sides2].sort((a, b) => a.id - b.id);
      
  //     return sorted1.every((side, index) => 
  //         side.id === sorted2[index].id &&
  //         side.name === sorted2[index].name &&
  //         side.price === sorted2[index].price
  //     );
  // }
  isSideSelected(sideId: number): boolean {
    return this.selectedFreeSides.some(side => side.id === sideId);
  }
  // Extra Products with Quantity Methods
  increaseExtraQuantity(extra: any) {
    if (!this.extraQuantities[extra.id]) {
        this.extraQuantities[extra.id] = 0;
    }
    this.extraQuantities[extra.id]++;
    this.updateSelectedExtras();
  }

  decreaseExtraQuantity(extra: any) {
    if (this.extraQuantities[extra.id] > 0) {
        this.extraQuantities[extra.id]--;
        this.updateSelectedExtras();
    }
  }
  toggleFreeSide(side: any) {
    const index = this.selectedFreeSides.findIndex(s => s.id === side.id);
    
    if (index > -1) {
        // Remove if already selected
        this.selectedFreeSides.splice(index, 1);
    } else {
        // Add if not reached max
        if (this.selectedFreeSides.length < this.selectedProduct.free_side) {
            this.selectedFreeSides.push(side);
        } else {
            this.alertService.danger(`You can only select ${this.selectedProduct.free_side} free sides`);
        }
    }
  }
  getExtraQuantity(extraId: number): number {
    return this.extraQuantities[extraId] || 0;
  }


  // final methods
  calculateOriginalTotal(): number {
    if (!this.selectedProduct || !this.selectedSize) return 0;
    
    const selectedType = this.selectedProduct.types.find(t => t.id === this.selectedSize);
    if (!selectedType) return 0;
    
    let total = selectedType.price * this.quantity;
    
    // Add extras
    if (this.selectedProduct.extraproducts) {
    this.selectedProduct.extraproducts.forEach(extra => {
        const quantity = this.extraQuantities[extra.id] || 0;
        if (quantity > 0) {
        total += extra.price * quantity * this.quantity;
        }
    });
    }
    
    // Add free sides with price
    if (this.selectedFreeSides && this.selectedFreeSides.length > 0) {
    this.selectedFreeSides.forEach(side => {
        if (side.price && side.price > 0) {
        total += side.price * this.quantity;
        }
    });
    }
    
    return total;
}

  calculateTotal(): number {
      if (!this.selectedProduct || !this.selectedSize) return 0;
      
      // Find the selected size
      const selectedType = this.selectedProduct.types.find(t => t.id === this.selectedSize);
      if (!selectedType) return 0;
      
      // Calculate base price (with discount if applicable)
      let basePrice = this.selectedProduct.offer 
      ? this.calculateDiscountedPrice2(this.selectedProduct, selectedType.price)
      : selectedType.price;
      
      let total = basePrice * this.quantity;
      
      // Add extras with quantity
      if (this.selectedProduct.extraproducts) {
      this.selectedProduct.extraproducts.forEach(extra => {
          const quantity = this.extraQuantities[extra.id] || 0;
          if (quantity > 0) {
          total += extra.price * quantity * this.quantity;
          }
      });
      }
      
      // Add free sides with price
      if (this.selectedFreeSides && this.selectedFreeSides.length > 0) {
      this.selectedFreeSides.forEach(side => {
          if (side.price && side.price > 0) {
          total += side.price * this.quantity;
          }
      });
      }
      
      return total;
  }

    // Optional: Helper function to calculate just free sides total
  calculateFreeSidesTotal(): number {
      if (!this.selectedFreeSides || this.selectedFreeSides.length === 0) return 0;
      
      return this.selectedFreeSides.reduce((total, side) => {
          return total + (side.price && side.price > 0 ? side.price : 0);
      }, 0) * this.quantity;
  }

  private areExtrasEqualNewFormat(extras1: any[], extras2: any[]): boolean {
      if (!extras1 && !extras2) return true;
      if (!extras1 || !extras2) return false;
      if (extras1.length !== extras2.length) return false;
      
      // Sort both arrays by name for consistent comparison
      const sorted1 = [...extras1].sort((a, b) => a.name.localeCompare(b.name));
      const sorted2 = [...extras2].sort((a, b) => a.name.localeCompare(b.name));
      
      // Compare each extra by name, quantity, and price
      return sorted1.every((extra, index) => 
          extra.name === sorted2[index].name &&
          extra.quantity === sorted2[index].quantity &&
          extra.price === sorted2[index].price
      );
  }

  // Helper method to compare free sides as objects
  private areFreeSidesEqualObjects(sides1: any[], sides2: any[]): boolean {
      if (!sides1 && !sides2) return true;
      if (!sides1 || !sides2) return false;
      if (sides1.length !== sides2.length) return false;
      
      // Sort both arrays by id for consistent comparison
      const sorted1 = [...sides1].sort((a, b) => a.id - b.id);
      const sorted2 = [...sides2].sort((a, b) => a.id - b.id);
      
      // Compare each side by id, name, and price
      return sorted1.every((side, index) => 
          side.id === sorted2[index].id &&
          side.name === sorted2[index].name &&
          side.price === sorted2[index].price
      );
  }
}
